import React, { createContext, useContext, useRef } from "react";
const ButtonRegistryContext = createContext();

export const ButtonRegistryProvider = ({ children }) => {
  const registryRef = useRef({});
  const listenersRef = useRef({});

const registerButton = (id, ref) => {
  registryRef.current[id] = ref;

  if (listenersRef.current[id]) {
    listenersRef.current[id].forEach((cb) => cb(ref));
    delete listenersRef.current[id];
  }
};

  const triggerButtonClick = (id) => {
    const ref = registryRef.current[id];
    if (ref?.current) {
      ref.current.click();
    }
  };

  const getButtonRef = (id) => registryRef.current[id] || null;

 const onButtonRegistered = (id, cb) => {
  const ref = getButtonRef(id);

  if (ref?.current) {
    cb(ref);
  } else {
    if (!listenersRef.current[id]) {
      listenersRef.current[id] = [];
    }
    listenersRef.current[id].push(cb);
  }
};

  return (
    <ButtonRegistryContext.Provider
      value={{ registerButton, triggerButtonClick, onButtonRegistered, getButtonRef }}
    >
      {children}
    </ButtonRegistryContext.Provider>
  );
};

export const useButtonRegistry = () => useContext(ButtonRegistryContext);
